import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminUsers = lazy(() => import("@/pages/admin/AdminUsers"));

export const Route = createFileRoute("/admin/anvandare")({
  component: () => <AdminUsers adminsOnly={false} />,
});
